/*eslint no-global-assign: off*/
/*eslint no-unused-vars: off*/
/* global woof_select_direct_search  */
/* global woof_current_values */
/* global woof_submit_link */
/* global woof_ajax_page_num:writable */
/* global woof_autosubmit */
/* global woof_get_submit_link */
/* exported woof_init_colors */

window.woof_init_colors = function() {
  // if (is_woof_use_chosen) {
  //   try {
  //     // jQuery("select.woof_select").chosen('destroy').trigger("liszt:updated");
  //     jQuery(".woof_list_color").chosen(/*{disable_search_threshold: 10}*/);
  //   } catch (e) {
  //
  //   }
  // }

  $('.woof_list_color').change(function () {
    console.log($(this));
    var slug = jQuery(this).val();
    var name = jQuery(this).attr('name');
    woof_color_direct_search(this, name, slug);
  });
}

function woof_color_direct_search(_this, name, slug) {

  jQuery.each(woof_current_values, function (index, value) {
      if (index == name) {
        delete woof_current_values[name];
        return;
      }
    });

    if (slug != 0) {
      woof_current_values[name] = slug;
    }

    woof_ajax_page_num = 1;
    if (woof_autosubmit || jQuery(_this).within('.woof').length == 0) {
      woof_submit_link(woof_get_submit_link());
  }

}


